/**
 * Sistema
 * @author Simpli CLI generator
 */
import {$, ID, Resource, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import SistemaSchema from '@/schema/Sistema.schema'

export default class Sistema extends Resource {
  readonly $name: string = 'Sistema'

  readonly $endpoint: string = '/user/sistema{/id}'

  get $schema() {
    return SistemaSchema(this)
  }

  get $id() {
    return this.idSistemaPk
  }
  set $id(val: ID) {
    this.idSistemaPk = val
  }
  get $tag() {
    return this.nome && this.nome !== 'null' ? this.nome : $.t('app.itrackPortal')
  }
  set $tag(val: TAG) {
    this.nome = val
  }

  idSistemaPk: ID = 0

  @ValidationRequired()
  @ValidationMaxLength(100)
  nome: string = ''

  @ValidationRequired()
  ativo: boolean = false

  async persistSistema(model?: Sistema, spinner = 'persistSistema') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/sistema`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getSistema(id: number, spinner = 'getSistema') {
    const fetch = async () => await this.GET(`/user/sistema/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeSistema(id: number, spinner = 'removeSistema') {
    const fetch = async () => await this.DELETE(`/user/sistema/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
